import { render } from "./EditEvaluationColumns.vue?vue&type=template&id=54e91aee"
import script from "./EditEvaluationColumns.vue?vue&type=script&lang=js"
export * from "./EditEvaluationColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__